import { Injectable } from '@angular/core';
import { User } from '../../models/user';
import { HttpService } from './http.service';

@Injectable({
  providedIn: 'root',
})
export class AuthApiService {
  constructor(private http: HttpService) {}

  buildurl(path: string, queryMap: any = null): string {
    return this.http.buildurl('/auth' + path, queryMap);
  }
  signup(
    email: string,
    fname: string,
    lname: string,
    password: string
  ): Promise<boolean> {
    const url = this.buildurl('/signup');
    const body = { email, password, fname, lname };
    return this.http.post(url, body);
  }

  rensendSignupEmail(email: string): Promise<boolean> {
    const url = this.buildurl('/signup/email');
    const body = { email };
    return this.http.post(url, body);
  }

  login(email: string, password: string, remember?: boolean): Promise<User> {
    const url = this.buildurl('/login');
    const body = { email, password, remember };
    return this.http.put(url, body);
  }

  loginWithGoogle(token: string): Promise<User> {
    const url = this.buildurl('/login/google');
    const body = { token };
    return this.http.put(url, body);
  }

  getProfile(): Promise<User> {
    const url = this.buildurl('/profile');
    return this.http.fget(url);
  }

  updateProfile({
    fname,
    lname,
  }: {
    fname: string;
    lname: string;
  }): Promise<User> {
    const url = this.buildurl('/profile');
    const body = { fname, lname };
    return this.http.put(url, body);
  }

  logout(): Promise<null> {
    const url = this.buildurl('/logout');
    return this.http.put(url, {});
  }

  sendResetPasswordEmail({
    email,
    token,
  }: {
    email: string;
    token: string;
  }): Promise<boolean> {
    const url = this.buildurl('/password-reset-email');
    const body = { email, token };
    return this.http.post(url, body);
  }

  signupVerification({
    token,
    nonce,
  }: {
    token: string;
    nonce: string;
  }): Promise<boolean> {
    const url = this.buildurl('/signup/verification');
    const body = { token, nonce };
    return this.http.post(url, body);
  }

  resetPassword({
    token,
    nonce,
    password,
  }: {
    token: string;
    nonce: string;
    password: string;
  }): Promise<boolean> {
    const url = this.buildurl('/password');
    const body = { token, nonce, password };
    return this.http.put(url, body);
  }
}
